/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Swedish (sv) string table · Shop V1/serum-c.html
   English is the source of truth in the HTML; this file supplies the
   Swedish counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-sv.js.

   House voice: calm, exact, short. No em dashes in prose (use periods,
   commas, or the mid-dot · ). Product names (Transderma C/A/O/M/R,
   Discovery Kit, Moisture Serum) and INCI/proper nouns stay in English.
   Claim-bearing strings are faithful renderings of the English source;
   nothing is strengthened, softened, or invented.
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.sv = window.TD_I18N.sv || {};
  Object.assign(window.TD_I18N.sv, {

    /* ── Breadcrumb ── */
    'serumC.crumb.home': 'Hem',
    'serumC.crumb.shop': 'Butik',
    'serumC.crumb.current': 'Serum C',

    /* ── Hero ── */
    'serumC.eyebrow': 'Vitamin C · Dag',
    'serumC.title': 'Serum <em>C.</em>',
    'serumC.tagline': 'Få fram en tidlös lyster med detta svenskfödda, kliniskt förfinade Vitamin C-elixir.',
    'serumC.price.size': '30 ml · Ensam eller staplingsbar',
    'serumC.cta.add': 'Lägg i varukorg · $175',
    'serumC.meta.sku.label': 'SKU',
    'serumC.meta.madein.label': 'Tillverkad i',
    'serumC.meta.madein.value': 'Sverige',
    'serumC.meta.ingredients.label': 'Ingredienser',
    'serumC.meta.ingredients.value': '2 — båda funktionella',
    'serumC.meta.shelf.label': 'Hållbarhet',
    'serumC.meta.shelf.value': '2 år, lufttät',

    /* ── Accordion: The work ── */
    'serumC.work.label': 'Verkan',
    'serumC.work.title': 'Kollagen, lyster, <em>vid källan.</em>',
    'serumC.work.p1': 'Serum C levererar ren <strong>L-askorbinsyra</strong> förbi hudens yta och in i dermis, där fibroblaster faktiskt producerar kollagen och elastin. På egen hand ger Vitamin C lyster och jämnar ut hudtonen, ljusar upp mörka fläckar, mjukar upp fina linjer och återställer den sortens lyster som kommer från cellfunktion, inte smink.',
    'serumC.work.p2': 'Formuleringen använder Dr. Ronláns egenutvecklade <strong>stabiliseringssystem</strong>, ett leveransmedel som skyddar Vitamin C mot oxidation och bär det intakt genom stratum corneum. Det är därför vårt serum inte blir orange, och varför den lägre koncentrationen på 10% överträffar de 20-procentiga vattenbaserade formlerna som andra varumärken förlitar sig på.',
    'serumC.work.quote': '"Den enklare versionen är att tillsätta vatten, sänka koncentrationen och tillsätta konserveringsmedel. Det har vi tackat nej till i trettio år."',
    'serumC.work.p3': 'Serum C är <strong>grunden</strong> i Transderma-systemet: det första serum de flesta kunder köper, och det som ofta övertygar dem om resten. Använt ensamt är det en komplett rutin. Staplat med Serum A på kvällen eller Serum M för fukt blir det ett system.',

    /* ── Accordion: Ingredients ── */
    'serumC.ing.label': 'Ingredienser',
    'serumC.ing.title': 'Två ingredienser. <em>Båda funktionella.</em>',
    'serumC.ing.intro': 'Varje ingrediens här har en uppgift. Det finns inget vatten, inget förtjockningsmedel, ingen parfym, inget konserveringsmedel, eftersom det inte finns någon kontaminationsrisk att skydda mot. Den lufttäta flaskan sköter det.',
    'serumC.ing.1.name': 'Organic 1,2-Propanediol <em>Leveransmedel</em>',
    'serumC.ing.1.note': 'Ett naturligt, växtbaserat lösningsmedel som bär Vitamin C genom lipidbarriären i stratum corneum utan irritation. Det är skälet till att den aktiva substansen når dermis intakt.',
    'serumC.ing.2.name': 'L-Ascorbic Acid <em>Rent Vitamin C · 10%</em>',
    'serumC.ing.2.note': 'Den bioaktiva formen av Vitamin C. Stimulerar kollagensyntes, neutraliserar fria radikaler, hämmar pigmentbildning. Vid 10% i en icke-vattenbaserad bas överträffar det 20-procentiga vattenbaserade formler utan irritationen.',

    /* ── Accordion: How to use ── */
    'serumC.howto.label': 'Användning',
    'serumC.howto.title': 'Ren hud, <em>några droppar.</em>',
    'serumC.howto.intro': 'Applicera på ren, torr hud. Låt serumet absorberas under en till fem minuter. Lägg på Serum M om din hud behöver fukt, låt absorberas helt, fortsätt sedan med din dagliga rutin. Morgon föredras.',
    'serumC.howto.step1.title': 'Ren, torr hud',
    'serumC.howto.step1.body': 'Rengör ansikte och hals. En till två droppar på bar hud; ingen toner eller kräm under.',
    'serumC.howto.step2.title': 'Låt absorberas',
    'serumC.howto.step2.body': 'En till fem minuter för att serumet ska sjunka in helt.',
    'serumC.howto.step3.title': 'Lägg på vid behov',
    'serumC.howto.step3.body': 'Avsluta med Transderma Moisture Serum (M) vid behov, eller stapla med Serum O eller A. Låt det absorberas helt.',
    'serumC.howto.step4.title': 'Fortsätt rutinen',
    'serumC.howto.step4.body': 'När det absorberats helt kan du fortsätta med din vanliga rutin. C är komplett på egen hand.',
    'serumC.howto.note': '<strong>När du ska använda det:</strong> En eller två gånger dagligen, morgon föredras. Fungerar som en fristående rutin eller som grunden i ett lagervis system med Serum A, O, M eller R.',

    /* ── Benefits ── */
    'serumC.bene.label': 'Vad det gör',
    'serumC.bene.title': 'Byggt för<br><em style="font-style:italic;color:var(--bark)">fem uppgifter.</em>',
    'serumC.bene.intro': 'Varje fördel går tillbaka till en specifik biologisk mekanism, inte en marknadsföringskategori. Om ett påstående inte är kopplat till hur molekylen beter sig i dermis hör det inte hemma på flaskan.',
    'serumC.bene.1.title': 'Kollagen &amp; elastin',
    'serumC.bene.1.body': 'Stimulerar fibroblasternas produktion av båda strukturproteinerna: de som håller huden fast och elastisk.',
    'serumC.bene.2.title': 'Antioxidantskydd',
    'serumC.bene.2.body': 'Neutraliserar fria radikaler från UV, föroreningar och ämnesomsättning. En av de mest studerade topikala antioxidanterna som finns.',
    'serumC.bene.3.title': 'Lyster &amp; ton',
    'serumC.bene.3.body': 'Hämmar tyrosinas, enzymet som driver pigmentbildning, jämnar ut missfärgning och återställer lyster.',
    'serumC.bene.4.title': 'Fina linjer &amp; ärr',
    'serumC.bene.4.body': 'Samma kollagenstöd som ger huden fasthet mjukar med tiden även upp synligheten av fina linjer, ytliga ärr och solskador.',

    /* ── Pairs with ── */
    'serumC.pairs.label': 'Passar med',
    'serumC.pairs.title': 'Systemet<br><em>kring Serum C.</em>',
    'serumC.pairs.intro': 'Använt ensamt är Serum C komplett. Använt med ett av dessa blir det en rutin. Varje serum tar vid där C slutar.',
    'serumC.pairs.a.role': 'Kväll · Förnyelse',
    'serumC.pairs.a.desc': 'Retinyl palmitate + Vitamin E. Cellförnyelse, rynkor, struktur. Verkar motsatt C: C på dagen, A på kvällen.',
    'serumC.pairs.m.role': 'Dag &amp; Kväll · Barriär',
    'serumC.pairs.m.desc': 'Ceramider och hudidentiska lipider. Lägg på efter att C absorberats helt för att återuppbygga fuktbarriären inifrån.',
    'serumC.pairs.o.role': 'Dag · Cellulär energi',
    'serumC.pairs.o.desc': 'PQQ, B-vitaminer, kreatin. Ger näring åt mitokondriernas funktion, motorn bakom det kollagen C stimulerar.',

    /* ── Delivery & returns ── */
    'serumC.del.shipping.title': 'Frakt',
    'serumC.del.shipping.body': 'Fri standardfrakt på beställningar över $150. Levereras världen över från Stockholm. <a href="../shipping-returns.html">Fullständiga fraktuppgifter</a>.',
    'serumC.del.returns.title': 'Returer',
    'serumC.del.returns.body': '14 dagar från fakturadatum. Produkter i originalförpackning, återbetalas till den ursprungliga betalningsmetoden. <a href="../shipping-returns.html">Returpolicy</a>.',
    'serumC.del.approved.title': 'Godkänd &amp; registrerad',
    'serumC.del.approved.body': 'Laboratoriegodkänd av Läkemedelsverket. Registrerad under EU:s kosmetikalagstiftning. Aldrig testad på djur.',

    /* ── Shopify theme variants (different link paths, drift) ── */
    'serumC.del.shipping.body.theme': 'Fri standardfrakt på beställningar över $150. Levereras världen över från Stockholm. <a href="/pages/shipping-returns">Fullständiga fraktuppgifter</a>.',
    'serumC.del.returns.body.theme': '14 dagar från fakturadatum. Produkter i originalförpackning, återbetalas till den ursprungliga betalningsmetoden. <a href="/pages/shipping-returns">Returpolicy</a>.',
    'serumC.howto.step3.title.moisture': 'Avsluta med fukt'

  });
})();
